<template>
	<div>
		<h2>Join Room</h2>
		<form class="create-room" method="post" @submit.prevent="onSubmit">
			<p>
				<label for="room_code">Room Code: </label>
				<input id="room_code" v-model="room_code" type="text" />
			</p>
			<p>
				<label for="room_username">Username: </label>
				<input id="room_username" v-model="username" type="text" />
			</p>
			<p>
				<input type="submit" />
			</p>
		</form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			room_code: '',
			username: '',
		};
	},
	methods: {
		onSubmit() {
			this.$store.dispatch('join_room', {
				room_code: this.room_code,
				username: this.username,
			});
		},
	},
};
</script>
